if (!customElements.get("pcard-swatch")) {
  class ProductCardColorSwatch extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        container: "[data-pcard-variant-picker]",
        optionNodes: [".m-product-option--node__label"],
        variantDropdown: ".m-product-option--dropdown-select",
        pcard: ".m-product-card",
      };
      this.container = this.closest(this.selectors.container);
      this.pcard = this.closest(this.selectors.pcard);
      this.domNodes = queryDomNodes(this.selectors, this.pcard);
      this.initializeData();
    }

    async initializeData() {
      this.variantData = this.fetchVariantData();
      this.productHandle = this.container.dataset.productHandle;
      this.productData = await this.fetchProductJson();
      this.activeOptionNodeByPosition = {};

      // Set initial variant for reference
      const { productData, productData: { variants } = {} } = this;
      if (productData) {
        const currentVariantId = productData.selected_or_first_available_variant?.id || variants[0]?.id;
        this.currentVariant = variants.find((v) => v.id === currentVariantId) || variants[0];
      }

      // Add event listeners
      if (this.domNodes.optionNodes) {
        this.domNodes.optionNodes.forEach((node) =>
          node.addEventListener("click", this.handleVariantSelection.bind(this))
        );
      }
      if (this.domNodes.variantDropdown) {
        this.domNodes.variantDropdown.addEventListener("change", this.handleVariantSelection.bind(this));
      }
    }

    fetchVariantData() {
      const jsonElement = this.container?.querySelector('[type="application/json"]');
      return jsonElement ? JSON.parse(jsonElement.textContent) : {};
    }

    fetchProductJson() {
      const productUrl = `${window.MinimogSettings.routes.root}/products/${this.productHandle}.js`.replace("//", "/");
      return fetch(productUrl).then((response) => response.json());
    }

    handleVariantSelection(e) {
      let target = e.target;
      let newVariant;

      if (target.classList.contains("combined-variant")) {
        const variantId = Number(target.value);
        newVariant = this.productData?.variants?.find((v) => v.id === variantId);
      } else {
        if (target.tagName === "SELECT") {
          target = target.querySelectorAll("option")[target.selectedIndex];
        }
        if (!target.classList.contains("m-product-option--node__label")) {
          target = target.closest(".m-product-option--node__label");
          if (!target) return;
        }
        const { optionPosition } = target.dataset;

        // Toggle active option
        const currActiveOptNode = this.activeOptionNodeByPosition[optionPosition];
        if (currActiveOptNode) currActiveOptNode.dataset.selected = "";
        target.dataset.selected = "true";
        this.activeOptionNodeByPosition[optionPosition] = target;

        // Get new variant
        newVariant = this.getVariantFromActiveOptions();
      }

      if (newVariant) {
        const productUrl = this.productData.url || `/products/${this.productHandle}`;
        const variantUrl = `${productUrl}?variant=${newVariant.id}`;
        window.location.href = variantUrl;
      }
    }

    getVariantFromActiveOptions() {
      const { productData, productData: { variants } = {} } = this;
      const options = Object.values(this.activeOptionNodeByPosition).map(node => node.dataset.value);
      return variants.find((v) => options.every((opt, idx) => opt === v.options[idx]));
    }
  }

  customElements.define("pcard-swatch", ProductCardColorSwatch);
}